module.exports = __webpack_public_path__ + "media/images/product_large_images/printer2-ac09e9e297d618c5e811aa07a4264d47.png";